export class GetNotifications {
  static readonly type = '[Notification] Get Notifications';

  constructor(public forceRefresh = false) {}
}
